import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./linkArticlesCards.scss";

import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Slider from "react-slick";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { findRel } from "../../../shared/utils/stringUtilities";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

const LinkArticlesCards = (props: ReferenciaContenido) => {
  const component = (dots) => {
    return (
      <div style={{ bottom: "-10px" }}>
        <ul>{dots}</ul>
      </div>
    );
  };

  const datasCards = props.referenciaPlantillaContenido;
  const { nombreCategoria } = props;
  const settings = {
    className: "m-link-article__slider",
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1, //TODO: to create less dots
    rows: 2,
    appendDots: (dots) => component(dots),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1.04,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.04,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          appendDots: (dots) => component(dots),
        },
      },
    ],
  };
  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };
  return (
    <>
      <div className="m-link-article">
        {props.tituloGeneral ? "" : <hr className="hide-on-mobile" />}
        {props.tituloGeneral ? (
          <h2 className="m-link-article-title">
            {props.tituloGeneral ? props.tituloGeneral : ""}
          </h2>
        ) : (
          ""
        )}

        <div className="m-link-article__cards-container">
          <Slider {...settings}>
            {datasCards.map((val, i) => {
              return (
                <div
                  key={i}
                  className={`gtmRedDeAmorMiniContenido${normalizeTwoWords(
                    val.tituloBanner
                  )}`}
                >
                  <a
                    className={`${
                      nombreCategoria === "Biblioteca"
                        ? `gtmRedDeAmorMiniContenido${normalizeTwoWords(
                            val.tituloBanner
                          )}`
                        : ""
                    }`}
                    href={val.redireccionBoton}
                    target={isHttp(val.redireccionBoton) ? "_blank" : "_self"}
                    rel={findRel(val.redireccionBoton)}
                  >
                    <div
                      className={`m-link-article-cards   gtmRedDeAmorMiniContenido${normalizeTwoWords(
                        val.tituloBanner
                      )}`}
                    >
                      <img
                        className={`gtmRedDeAmorMiniContenido${normalizeTwoWords(
                          val.tituloBanner
                        )}`}
                        src={val.imagenPrincipal[0].file.url}
                        alt={val.imagenPrincipal[0].title}
                      />
                      <div
                        className={`m-link-article-cards-information  gtmRedDeAmorMiniContenido${normalizeTwoWords(
                          val.tituloBanner
                        )}`}
                      >
                        <h4
                          className={`m-link-article-cards-information-title  gtmRedDeAmorMiniContenido${normalizeTwoWords(
                            val.tituloBanner
                          )}`}
                        >
                          {val.tituloBanner}
                        </h4>
                        <div
                          className={`m-link-article-cards-information-description  gtmRedDeAmorMiniContenido${normalizeTwoWords(
                            val.tituloBanner
                          )}`}
                        >
                          {documentToReactComponents(
                            JSON.parse(val?.descripcion?.raw)
                          )}
                        </div>
                        <span
                          className={`m-link-minicards-information-dates  gtmRedDeAmorMiniContenido${normalizeTwoWords(
                            val.tituloBanner
                          )}`}
                        >
                          {val.tituloDescripcion}
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default LinkArticlesCards;
